document.querySelectorAll('[data-hero-boutique]').forEach((hero) => {
  const scenes = Array.from(hero.querySelectorAll('[data-scene]'));
  if (scenes.length === 0) return;
  let current = 0;

  function getVideo(scene) {
    return scene.querySelector('video');
  }

  function playScene(index) {
    scenes.forEach((scene, i) => {
      const video = getVideo(scene);
      if (i === index) {
        scene.classList.add('is-active');
        if (video) {
          video.currentTime = 0;
          video.play().catch(() => {});
        }
      } else {
        scene.classList.remove('is-active');
        if (video) video.pause();
      }
    });
  }

  function goToNext() {
    current = (current + 1) % scenes.length;
    playScene(current);
  }

  scenes.forEach((scene, i) => {
    const video = getVideo(scene);
    if (!video) return;
    video.muted = true;
    video.playsInline = true;
    video.addEventListener('ended', () => {
      if (i === current) goToNext();
    });
  });

  playScene(0);
});